'use client';

// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable react/jsx-handler-names */
import { Controller, useFormContext } from 'react-hook-form';
import type { FormType, NumberInputInputProps } from '../../types/types';
import { NumberInputField, NumberInputRoot } from '../../../components/ui';

import { FormField } from '../FormField/FormField';

export const FormNumericInput = <T extends FormType>({
	name,
	label,
	helperText,
	optionalText,
	isRequired,
	_formField,
	...rest
}: NumberInputInputProps<T>) => {
	const { control } = useFormContext();

	return (
		<FormField
			helperText={helperText}
			label={label}
			name={name}
			optionalText={optionalText}
			required={isRequired}
			{..._formField}
		>
			<Controller
				control={control}
				name={name}
				render={({ field }) => (
					<NumberInputRoot
						disabled={field.disabled}
						name={field.name}
						value={field.value}
						onValueChange={({ value }) => {
							field.onChange(value);
						}}
						{...rest}
					>
						<NumberInputField onBlur={field.onBlur} />
					</NumberInputRoot>
				)}
			/>
		</FormField>
	);
};